var SharedUser, SupportAPIHelper, SupportAjaxShimTemplate, async, callWasInterrupted;

async = require('../../../../core/frontend/vendor_modules/async');

SharedUser = require('../../../shared/frontend/helpers/user');

SupportAjaxShimTemplate = require('../../ajax_shim.html.mustache');

callWasInterrupted = function(status, errorMessage) {
  return status === 'abort' || (errorMessage == null) || (errorMessage != null ? errorMessage.length : void 0) === 0;
};

SupportAPIHelper = {
  httpErrorHandler: (function(_this) {
    return function(response, status, errorMessage) {
      if (callWasInterrupted(status, errorMessage)) {
        return;
      }
      flash('error', 'Sorry something went wrong');
      return $('#g-spinner').hide();
    };
  })(this),
  errorHandler: function(errorMessage) {
    return flash('error', errorMessage);
  },
  parallel: function(urls, datas, responseCallback, blockUI, timer, timeout, methods) {
    var callbacks, errorCb, requests, successCb;
    if (methods == null) {
      methods = [];
    }
    successCb = function(cb) {
      return (function(_this) {
        return function(response) {
          return cb(null, response);
        };
      })(this);
    };
    errorCb = function(cb) {
      return (function(_this) {
        return function(errorMessage) {
          return cb(null, null);
        };
      })(this);
    };
    requests = [];
    callbacks = [];
    _.each(urls, (function(_this) {
      return function(url, index) {
        return callbacks.push(function(cb) {
          var req;
          if (methods[index] != null) {
            req = _this.call(url, methods[index], datas[index], successCb(cb), errorCb(cb), blockUI, timer, timeout);
          } else {
            req = _this.get(url, datas[index], successCb(cb), errorCb(cb), blockUI, timer, timeout);
          }
          return requests.push(req);
        });
      };
    })(this));
    async.parallel(callbacks, (function(_this) {
      return function(err, results) {
        if (err != null) {
          return responseCallback(null);
        }
        return responseCallback(results);
      };
    })(this));
    return requests;
  },
  get: function(url, data, success, error, blockUI, timer, timeout) {
    var args;
    if (timer == null) {
      timer = null;
    }
    if (timeout == null) {
      timeout = 70000;
    }
    args = Array.prototype.slice.call(arguments);
    switch (args.length) {
      case 2:
        success = data;
        data = void 0;
        break;
      case 3:
        if (typeof args[1] === 'function') {
          error = success;
          success = data;
          data = void 0;
        }
    }
    return this.call(url, 'GET', data, success, error, blockUI, timer, timeout);
  },
  call: function(url, method, data, successHandler, customErrorHandler, blockUI, timer, timeout) {
    var ajaxShimTemplate, options, request;
    if (timer == null) {
      timer = null;
    }
    if (timeout == null) {
      timeout = 70000;
    }
    data || (data = {});
    switch (method) {
      case 'PUT':
        method = 'POST';
        data._method = 'PUT';
        break;
      case 'DELETE':
        method = 'POST';
        data._method = 'DELETE';
    }
    if (blockUI) {
      ajaxShimTemplate = SupportAjaxShimTemplate.render({});
      $('body').append(ajaxShimTemplate);
    }
    options = {
      url: url,
      type: method,
      dataType: 'json',
      headers: {},
      timeout: timeout,
      data: data,
      error: (function(_this) {
        return function(err, status, errorMessage) {
          if (timer != null) {
            stopTimer(timer);
          }
          if (blockUI) {
            $('.ajaxshim').remove();
          }
          if (customErrorHandler) {
            return customErrorHandler(errorMessage);
          } else {
            return _this.httpErrorHandler(err, status, errorMessage);
          }
        };
      })(this),
      success: (function(_this) {
        return function(response) {
          if (timer != null) {
            stopTimer(timer);
          }
          $('.ajaxshim').remove();
          if (!response || response.length === 0 || (response.error != null)) {
            if (customErrorHandler != null) {
              return customErrorHandler(response);
            } else {
              return _this.errorHandler(null);
            }
          } else {
            return successHandler(response);
          }
        };
      })(this)
    };
    SharedUser.setGrpnUsrHeader(options);
    if (timer != null) {
      startTimer(timer);
    }
    request = $.ajax(options);
    return request;
  }
};

module.exports = SupportAPIHelper;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvaGVscGVycy9BUEkuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvaGVscGVycy9BUEkuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsS0FBQSxHQUFRLE9BQUEsQ0FBUSxnREFBUjs7QUFDUixVQUFBLEdBQWEsT0FBQSxDQUFRLHVDQUFSOztBQUNiLHVCQUFBLEdBQTBCLE9BQUEsQ0FBUSwrQkFBUjs7QUFFMUIsa0JBQUEsR0FBcUIsU0FBQyxNQUFELEVBQVMsWUFBVDtTQUNuQixNQUFBLEtBQVUsT0FBVixJQUFzQixzQkFBdEIsNEJBQXVDLFlBQVksQ0FBRSxnQkFBZCxLQUF3QjtBQUQ1Qzs7QUFHckIsZ0JBQUEsR0FDRTtFQUFBLGdCQUFBLEVBQWtCLENBQUEsU0FBQSxLQUFBO1dBQUEsU0FBQyxRQUFELEVBQVcsTUFBWCxFQUFtQixZQUFuQjtNQUNoQixJQUFVLGtCQUFBLENBQW1CLE1BQW5CLEVBQTJCLFlBQTNCLENBQVY7QUFBQSxlQUFBOztNQUNBLEtBQUEsQ0FBTSxPQUFOLEVBQWUsNEJBQWY7YUFDQSxDQUFBLENBQUUsWUFBRixDQUFlLENBQUMsSUFBaEIsQ0FBQTtJQUhnQjtFQUFBLENBQUEsQ0FBQSxDQUFBLElBQUEsQ0FBbEI7RUFLQSxZQUFBLEVBQWMsU0FBQyxZQUFEO1dBQ1osS0FBQSxDQUFNLE9BQU4sRUFBZSxZQUFmO0VBRFksQ0FMZDtFQVFBLFFBQUEsRUFBVSxTQUFDLElBQUQsRUFBTyxLQUFQLEVBQWMsZ0JBQWQsRUFBZ0MsT0FBaEMsRUFBeUMsS0FBekMsRUFBZ0QsT0FBaEQsRUFBeUQsT0FBekQ7QUFDUixRQUFBOztNQURpRSxVQUFVOztJQUMzRSxTQUFBLEdBQVksU0FBQyxFQUFEO2FBQ1YsQ0FBQSxTQUFBLEtBQUE7ZUFBQSxTQUFDLFFBQUQ7aUJBQ0UsRUFBQSxDQUFHLElBQUgsRUFBUyxRQUFUO1FBREY7TUFBQSxDQUFBLENBQUEsQ0FBQSxJQUFBO0lBRFU7SUFJWixPQUFBLEdBQVUsU0FBQyxFQUFEO2FBQ1IsQ0FBQSxTQUFBLEtBQUE7ZUFBQSxTQUFDLFlBQUQ7aUJBQ0UsRUFBQSxDQUFHLElBQUgsRUFBUyxJQUFUO1FBREY7TUFBQSxDQUFBLENBQUEsQ0FBQSxJQUFBO0lBRFE7SUFJVixRQUFBLEdBQVk7SUFDWixTQUFBLEdBQVk7SUFDWixDQUFDLENBQUMsSUFBRixDQUFPLElBQVAsRUFBYSxDQUFBLFNBQUEsS0FBQTthQUFBLFNBQUMsR0FBRCxFQUFNLEtBQU47ZUFDWCxTQUFTLENBQUMsSUFBVixDQUNFLFNBQUMsRUFBRDtBQUNFLGNBQUE7VUFBQSxJQUFHLHNCQUFIO1lBQ0UsR0FBQSxHQUFNLEtBQUMsQ0FBQSxJQUFELENBQU0sR0FBTixFQUFXLE9BQVEsQ0FBQSxLQUFBLENBQW5CLEVBQTJCLEtBQU0sQ0FBQSxLQUFBLENBQWpDLEVBQXlDLFNBQUEsQ0FBVSxFQUFWLENBQXpDLEVBQXdELE9BQUEsQ0FBUSxFQUFSLENBQXhELEVBQXFFLE9BQXJFLEVBQThFLEtBQTlFLEVBQXFGLE9BQXJGLEVBRFI7V0FBQSxNQUFBO1lBR0UsR0FBQSxHQUFNLEtBQUMsQ0FBQSxHQUFELENBQUssR0FBTCxFQUFVLEtBQU0sQ0FBQSxLQUFBLENBQWhCLEVBQXdCLFNBQUEsQ0FBVSxFQUFWLENBQXhCLEVBQXVDLE9BQUEsQ0FBUSxFQUFSLENBQXZDLEVBQW9ELE9BQXBELEVBQTZELEtBQTdELEVBQW9FLE9BQXBFLEVBSFI7O2lCQUlBLFFBQVEsQ0FBQyxJQUFULENBQWMsR0FBZDtRQUxGLENBREY7TUFEVztJQUFBLENBQUEsQ0FBQSxDQUFBLElBQUEsQ0FBYjtJQVVBLEtBQUssQ0FBQyxRQUFOLENBQWUsU0FBZixFQUEwQixDQUFBLFNBQUEsS0FBQTthQUFBLFNBQUMsR0FBRCxFQUFNLE9BQU47UUFDeEIsSUFBRyxXQUFIO0FBQ0UsaUJBQU8sZ0JBQUEsQ0FBaUIsSUFBakIsRUFEVDs7ZUFFQSxnQkFBQSxDQUFpQixPQUFqQjtNQUh3QjtJQUFBLENBQUEsQ0FBQSxDQUFBLElBQUEsQ0FBMUI7V0FJQTtFQXpCUSxDQVJWO0VBbUNBLEdBQUEsRUFBSyxTQUFDLEdBQUQsRUFBTSxJQUFOLEVBQVksT0FBWixFQUFxQixLQUFyQixFQUE0QixPQUE1QixFQUFxQyxLQUFyQyxFQUFtRCxPQUFuRDtBQUNILFFBQUE7O01BRHdDLFFBQVE7OztNQUFNLFVBQVU7O0lBQ2hFLElBQUEsR0FBTyxLQUFLLENBQUMsU0FBUyxDQUFDLEtBQUssQ0FBQyxJQUF0QixDQUEyQixTQUEzQjtBQUVQLFlBQU8sSUFBSSxDQUFDLE1BQVo7QUFBQSxXQUNPLENBRFA7UUFFSSxPQUFBLEdBQVU7UUFDVixJQUFBLEdBQU87QUFGSjtBQURQLFdBSU8sQ0FKUDtRQUtJLElBQUcsT0FBTyxJQUFLLENBQUEsQ0FBQSxDQUFaLEtBQW1CLFVBQXRCO1VBQ0UsS0FBQSxHQUFRO1VBQ1IsT0FBQSxHQUFVO1VBQ1YsSUFBQSxHQUFPLE9BSFQ7O0FBTEo7QUFTQSxXQUFPLElBQUMsQ0FBQSxJQUFELENBQU0sR0FBTixFQUFXLEtBQVgsRUFBa0IsSUFBbEIsRUFBd0IsT0FBeEIsRUFBaUMsS0FBakMsRUFBd0MsT0FBeEMsRUFBaUQsS0FBakQsRUFBd0QsT0FBeEQ7RUFaSixDQW5DTDtFQWlEQSxJQUFBLEVBQU0sU0FBQyxHQUFELEVBQU0sTUFBTixFQUFjLElBQWQsRUFBb0IsY0FBcEIsRUFBb0Msa0JBQXBDLEVBQXdELE9BQXhELEVBQWlFLEtBQWpFLEVBQStFLE9BQS9FO0FBQ0osUUFBQTs7TUFEcUUsUUFBUTs7O01BQU0sVUFBVTs7SUFDN0YsU0FBQSxPQUFTO0FBRVQsWUFBTyxNQUFQO0FBQUEsV0FDTyxLQURQO1FBRUksTUFBQSxHQUFTO1FBQ1QsSUFBSSxDQUFDLE9BQUwsR0FBZTtBQUZaO0FBRFAsV0FJTyxRQUpQO1FBS0ksTUFBQSxHQUFTO1FBQ1QsSUFBSSxDQUFDLE9BQUwsR0FBZTtBQU5uQjtJQU9BLElBQUcsT0FBSDtNQUNFLGdCQUFBLEdBQW1CLHVCQUF1QixDQUFDLE1BQXhCLENBQStCLEVBQS9CO01BQ25CLENBQUEsQ0FBRSxNQUFGLENBQVMsQ0FBQyxNQUFWLENBQWlCLGdCQUFqQixFQUZGOztJQUlBLE9BQUEsR0FDRTtNQUFBLEdBQUEsRUFBSyxHQUFMO01BQ0EsSUFBQSxFQUFNLE1BRE47TUFFQSxRQUFBLEVBQVUsTUFGVjtNQUdBLE9BQUEsRUFBUyxFQUhUO01BSUEsT0FBQSxFQUFTLE9BSlQ7TUFLQSxJQUFBLEVBQU0sSUFMTjtNQU1BLEtBQUEsRUFBTyxDQUFBLFNBQUEsS0FBQTtlQUFBLFNBQUMsR0FBRCxFQUFNLE1BQU4sRUFBYyxZQUFkO1VBQ0wsSUFBb0IsYUFBcEI7WUFBQSxTQUFBLENBQVUsS0FBVixFQUFBOztVQUNBLElBQTJCLE9BQTNCO1lBQUEsQ0FBQSxDQUFFLFdBQUYsQ0FBYyxDQUFDLE1BQWYsQ0FBQSxFQUFBOztVQUNBLElBQUcsa0JBQUg7bUJBQ0Usa0JBQUEsQ0FBbUIsWUFBbkIsRUFERjtXQUFBLE1BQUE7bUJBR0MsS0FBQyxDQUFBLGdCQUFELENBQWtCLEdBQWxCLEVBQXVCLE1BQXZCLEVBQStCLFlBQS9CLEVBSEQ7O1FBSEs7TUFBQSxDQUFBLENBQUEsQ0FBQSxJQUFBLENBTlA7TUFhQSxPQUFBLEVBQVMsQ0FBQSxTQUFBLEtBQUE7ZUFBQSxTQUFDLFFBQUQ7VUFDUCxJQUFvQixhQUFwQjtZQUFBLFNBQUEsQ0FBVSxLQUFWLEVBQUE7O1VBQ0EsQ0FBQSxDQUFFLFdBQUYsQ0FBYyxDQUFDLE1BQWYsQ0FBQTtVQUNBLElBQUcsQ0FBQyxRQUFELElBQWEsUUFBUSxDQUFDLE1BQVQsS0FBbUIsQ0FBaEMsSUFBcUMsd0JBQXhDO1lBQ0UsSUFBRywwQkFBSDtxQkFDRSxrQkFBQSxDQUFtQixRQUFuQixFQURGO2FBQUEsTUFBQTtxQkFHRSxLQUFDLENBQUEsWUFBRCxDQUFjLElBQWQsRUFIRjthQURGO1dBQUEsTUFBQTttQkFNRSxjQUFBLENBQWUsUUFBZixFQU5GOztRQUhPO01BQUEsQ0FBQSxDQUFBLENBQUEsSUFBQSxDQWJUOztJQXdCRixVQUFVLENBQUMsZ0JBQVgsQ0FBNEIsT0FBNUI7SUFFQSxJQUFxQixhQUFyQjtNQUFBLFVBQUEsQ0FBVyxLQUFYLEVBQUE7O0lBQ0EsT0FBQSxHQUFVLENBQUMsQ0FBQyxJQUFGLENBQU8sT0FBUDtXQUNWO0VBM0NJLENBakROOzs7QUE4RkYsTUFBTSxDQUFDLE9BQVAsR0FBaUIifQ==
